import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

const CARD_RADIUS = '24px';
const MIN_HEIGHT = '340px';

export const EmptyCard = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${space[5]};
  min-height: ${MIN_HEIGHT};
  padding: ${space[5]} ${space[7]};
  background: ${colors.lighterGrey};
  border-radius: ${CARD_RADIUS};
  text-align: center;
`;

export const EmptyHeading = styled.p`
  margin: 0;
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.normal};
  line-height: 1.2;
  color: ${colors.fontPrimary};
`;

export const PopulatedCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: ${space[5]};
  padding: ${space[5]};
  background: ${colors.white};
  border: 1px solid ${colors.borderGreyLighter};
  border-radius: ${CARD_RADIUS};
  min-height: ${MIN_HEIGHT};

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    align-items: stretch;
    gap: ${space[6]};
    padding: ${space[6]};
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  border-radius: 16px;
  background: ${colors.lighterGrey};
  flex-shrink: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: 40%;
    max-width: 360px;
    aspect-ratio: auto;
    align-self: stretch;
  }
`;

export const Image = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const ImagePlaceholder = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.fontSecondary};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  flex: 1;
  min-width: 0;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const FieldLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  line-height: 1.4;
  color: ${colors.fontSecondary};
`;

export const FieldValue = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: 1.4;
  color: ${colors.fontPrimary};
`;

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-end;
  padding: ${space[1]} ${space[3]};
  border-radius: ${layout.borderRadiusFull};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: 1.4;

  &[data-status='active'] {
    background: ${colors.successBackground};
    color: ${colors.success};
  }

  &[data-status='cancelled'] {
    background: ${colors.errorBackground};
    color: ${colors.error};
  }

  &[data-status='complete'] {
    background: ${colors.lighterGrey};
    color: ${colors.fontPrimary};
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: ${space[3]};
`;

export const LoadingPillSlot = styled.div`
  align-self: flex-end;
`;
